export const state = {
  enableSelectArea: false,
  polygon: {},
  polylines: [],
  selectedVehiclesToDisplay: [],
  mapObject: null,
  showResultDialog: false
}

export const mutations = {
  ENABLE_DRAW_SELECT_FEATURE(state) {
    state.enableSelectArea = !state.enableSelectArea
  },
  EMPTY_POLYGON_AND_POLYLINES(state) {
    state.polygon = {}
    state.polylines = []
  },
  ASSIGN_POLYGON(state, polygon) {
    state.polygon = polygon
  },
  ASSIGN_POLYLINE(state, polyline) {
    state.polylines.push(polyline)
  },
  EMPTY_POLYLINES(state) {
    state.polylines = []
  },
  ADD_VEHICLE_FOR_DISPLAY(state, vehicle) {
    state.selectedVehiclesToDisplay.push(vehicle)
  },
  EMPTY_VEHICLES_FOR_DISPLAY(state) {
    state.selectedVehiclesToDisplay = []
  },
  SET_MAP_OBJECT(state, map) {
    state.mapObject = map
  },
  SHOW_RESULT_DIALOG(state, value) {
    state.showResultDialog = value
  }
}

export const actions = {
  enableDrawSelectFeature({ commit }) {
    commit('ENABLE_DRAW_SELECT_FEATURE')
  },
  emptyPolygonAndPolylines({ commit }) {
    commit('EMPTY_POLYGON_AND_POLYLINES')
  },
  assignPolygonValue({ commit }, polygon) {
    commit('ASSIGN_POLYGON', polygon)
  },
  assignPolylinesValue({ commit }, polyline) {
    commit('ASSIGN_POLYLINE', polyline)
  },
  emptyPolylines({ commit }) {
    commit('EMPTY_POLYLINES')
  },
  addVehicleForDisplay({ commit }, vehicle) {
    commit('ADD_VEHICLE_FOR_DISPLAY', vehicle)
  },
  emptyVehiclesForDisplay({ commit }) {
    commit('EMPTY_VEHICLES_FOR_DISPLAY')
  },
  setMapObject({ commit }, map) {
    commit('SET_MAP_OBJECT', map)
  },
  showResultDialog({ commit }, value) {
    commit('SHOW_RESULT_DIALOG', value)
  }
}

export const getters = {}

export const namespaced = true
